import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  UpsertAndSingleSimulationOrderRequestInfo,
  UpsertAndSingleSimulationOrderResponseResult,
} from '@/coreInfrastructureModule/axios/generated/orderManage';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';
import { upsertAndSingleSimulationOrderAdapter } from './adapters/upsertAndSingleSimulationOrderAdapter';
import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
/**
 * 確定発注保存のビジネスロジック
 */
export class UpsertAndSingleSimulationOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注登録に使用するUseCase
   * DBの定義とIBusinessとの形式の差異をここで合わせて登録する
   * @param registerOrderInfo - 集計されていないビジネス
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisInfo - 発注根拠情報
   */
  public async Execute(
    registerOrderInfo: DisplayIArrival,
    aggregateBusinessId: string,
    orderBasisInfo: IOrderBasis
  ): Promise<INetworkResult<UpsertAndSingleSimulationOrderResponseResult, Error>> {
    const request: UpsertAndSingleSimulationOrderRequestInfo = upsertAndSingleSimulationOrderAdapter.requestAdapter(
      registerOrderInfo,
      aggregateBusinessId,
      orderBasisInfo
    );
    try {
      const result = await this.repository.upsertAndSingleSimulate(request);
      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
